import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import {
  resetgetKybDetailsReportList,
  getKybReportDetailsListReq,
} from "../../redux/actions/getKybDetailsListAction";
import { Row, Col, Card, CardTitle, CardBody } from "reactstrap";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BackButton from "../../components/BackButton/BackButton";
import GetAppIcon from "@mui/icons-material/GetApp";

import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { ExpandMore } from "@mui/icons-material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import ClearIcon from "@mui/icons-material/Clear";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { getKybApproveRejectReq } from "../../redux/actions/getKybApproveRejectAction";

const GetKybDetails = () => {
  const location = useLocation();
  const verificationID = location.state.param1;
  // console.log(verificationID);
  const customerID = location.state.param2;
  const userRole = location.state.param3;
  // console.log(customerID);
  const dispatch = useDispatch();
  // const partnerloginUser = useSelector(({ login }) => login);
  // var authToken = partnerloginUser.data.AuthToken;

  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  var authToken = regenerateTokenRes.data.AuthToken;

  const getKybDetailsListRes = useSelector(
    ({ getKybDetailsList }) => getKybDetailsList
  );

  const getKybDetailsFunc = () => {
    const getKybDetailsReq = {
      loginDetails: {
        walletOwnerId: regenerateTokenRes.data.partnerId || "",
      },
      actionCustomerMasterRequestVO: {
        verificationId: verificationID,
        customerId: customerID,
      },
    };

    return dispatch(getKybReportDetailsListReq(getKybDetailsReq, authToken));
  };

  useEffect(() => {
    if (regenerateTokenRes.data.status == "success") {
      getKybDetailsFunc();
    }
  }, [regenerateTokenRes.data.status, verificationID, customerID]);

  // const getKybDetailsRes = () => {
  //   if (getKybDetailsListStatus) {
  //     if (getKybDetailsListRes.data.status == "success") {
  //       // setGetKybDetailsListArray(getKybDetailsListRes.data)
  //       setGetKybDetailsListArray(obj)
  //     }
  //     if (getKybDetailsListRes.data.status == "Failed") {
  //       setGetKybDetailsListArray(getKybDetailsListRes.data)
  //     }
  //   }
  // }

  // useEffect(() => {
  //   getKybDetailsRes()
  // }, [getKybDetailsListRes.data.status])

  const handleAcceptOrRejectReq = (
    customerid, role, companyid, recommendation
  ) => {
    const acceptOrRejectReq = {
      actionCustomerMasterRequestVO: {
        walletOwnerId: regenerateTokenRes.data.partnerId,
        customerId: customerid,
        role: role,
        userName: regenerateTokenRes.data.LoginName,
        companyId: companyid,
        recommendation: recommendation
      }
    };
    dispatch(getKybApproveRejectReq(acceptOrRejectReq, authToken))
  }

  return (
    <>
      <Layout>
        <BackButton />
        <div
          style={{
            background: "",
            // marginTop: "6rem",
            paddingTop: "1rem",
            borderRadius: "5px",
          }}
        >
          <Box marginLeft={3} marginRight={3} paddingBottom={2}>
            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Registration Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>

                  <Col md={12}>
                    <Row className="detail-info row">
                      <Col md={6}>Parent ID:</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.customerId ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.customerId : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Role:</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.province ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.province : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Entity Type:</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.entityType ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.entityType : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Created By:</Col>
                      <Col md={6}>
                        {/* {getKybDetailsListRes &&
                          getKybDetailsListRes.data ?
                          getKybDetailsListRes &&
                          getKybDetailsListRes.data : "-"
                        } */}
                        -
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Modified By:</Col>
                      <Col md={6}>
                        {/* {getKybDetailsListRes &&
                          getKybDetailsListRes.data ?
                          getKybDetailsListRes &&
                          getKybDetailsListRes.data : "-"
                        } */}
                        -
                      </Col>
                    </Row>
                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <Typography
              variant="h6"
              component="div"
              className=""
              style={{
                fontSize: "1.4rem",
                marginBottom: "1.2rem",
                color: "#013c83",
              }}
            >
              Registration Details
            </Typography> */}
            {/* <Row>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Parent ID:</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.customerId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Role:</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.province}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Entity Type:</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.entityType}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Created By:</Col>
                  <Col md={6}>
                    {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                      getCustomerDetailsResArray.customerMasterDetailsResponseVO
                        .initiatedBy}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Modified By:</Col>
                  <Col md={6}>
                    {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                      getCustomerDetailsResArray.customerMasterDetailsResponseVO
                        .initiatedBy}
                  </Col>
                </Row>
              </Col>
            </Row> */}

            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Verification Registration Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <Col md={12}>
                    <Row className="detail-info row">
                      <Col md={6}>ACTION</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.action ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.action : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verification ID</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verificationId ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verificationId : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Request Id</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verificationId ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verificationId : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Request Status</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.regStatus ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.regStatus : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Request Date</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.regDate ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.regDate : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Response Id</Col>
                      <Col md={6}>-</Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verification Status</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verifyStatus ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verifyStatus : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Score</Col>
                      <Col md={6}>-</Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Recommendation </Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.recommendation ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.recommendation : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Confidence Level</Col>
                      <Col md={6}>-</Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verified On</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.recommendation ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.recommendation : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verified By</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verifiedBy ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybDetailsList &&
                          getKybDetailsListRes.data.kybDetailsList.verifiedBy : "-"
                        }
                      </Col>
                    </Row>
                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <div
              style={{
                marginTop: "2rem",
              }}
            ></div> */}

            {/* <Row>
              <h3
                style={{
                  marginTop: "4rem",
                  marginLeft: "1rem",
                  color: "#013c83",
                  fontSize: "1.4rem",
                }}
              >
                Verification Registation Details
              </h3>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>ACTION</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.action}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verification ID</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.verificationId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Request Id</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.verificationId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Request Status</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.regStatus}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Request Date</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.regDate}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Response Id</Col>
                  <Col md={6}></Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verification Status</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.verifyStatus}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Score</Col>
                  <Col md={6}></Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Recommendation </Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.recommendation}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Confidence Level</Col>
                  <Col md={6}></Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verified On</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.recommendation}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verified By</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybDetailsList &&
                      getKybDetailsListRes.data.kybDetailsList.verifiedBy}
                  </Col>
                </Row>
              </Col>
            </Row> */}

            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Company Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <Col md={12}>
                    <Row className="detail-info row">
                      <Col md={6}>Company ID</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyId ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyId : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Company Name</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyName ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyName : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Company Number</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyNumber ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.companyNumber : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Company Website</Col>
                      <Col md={6}>
                        {/* {
                      getKybDetailsListRes.data && getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.companyNumber
                    } */}
                        -
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Company Registered Date</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList
                            .companyRegisteredDate ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList
                            .companyRegisteredDate : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Tax Number</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.taxNumber ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.taxNumber : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Tax CountryISO</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.taxcountryISO ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.taxcountryISO : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Trading Name</Col>
                      <Col md={6}>
                        {/* {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.tradingCountryISO} */}
                        -
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Bussiness Type</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.businessType ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.businessType : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Bussiness Nature</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.businessNature ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.businessNature : "-"
                        }
                      </Col>
                    </Row>
                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <Row>
              <h3
                style={{
                  marginTop: "4rem",
                  marginLeft: "1rem",
                  color: "#013c83",
                  fontSize: "1.4rem",
                }}
              >
                Company Details
              </h3>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Company ID</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.companyId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Company Name</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.companyName}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Company Number</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.companyNumber}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Company Website</Col>
                  <Col md={6}>
                    {
                      getKybDetailsListRes.data && getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.companyNumber
                    }
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Company Registered Date</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList
                        .companyRegisteredDate}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Tax Number</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.taxNumber}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Tax CountryISO</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.taxcountryISO}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Trading Name</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.tradingCountryISO}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Bussiness Type</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.businessType}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Bussiness Nature</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.businessNature}
                  </Col>
                </Row>
              </Col>
            </Row> */}

            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Register Address Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <Col md={12}>
                    <Row className="detail-info row">
                      <Col md={6}>Address</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.address ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.address : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>State</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.state ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.state : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>City</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.city ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.city : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Zip</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.zip ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.zip : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Country Code</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.countryCode ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList.countryCode : "-"
                        }
                      </Col>
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Customer Ip Address</Col>
                      <Col md={6}>
                        {getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList
                            .customerIpAddress ?
                          getKybDetailsListRes.data &&
                          getKybDetailsListRes.data.kybAddressList &&
                          getKybDetailsListRes.data.kybAddressList
                            .customerIpAddress : "-"
                        }
                      </Col>
                    </Row>
                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <Row>
              <Typography
                variant="h6"
                component="div"
                className="mt-3"
                style={{
                  fontSize: "1.4rem",
                  marginLeft: "1rem",
                  marginTop: "4rem",
                  marginBottom: "1.2rem",
                  color: "#013c83",
                }}
              >
                Register Address Details
              </Typography>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Address</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.address}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>State</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.state}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>City</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.city}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Zip</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.zip}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Country Code</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.countryCode}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Customer Ip Address</Col>
                  <Col md={6}>
                    {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList
                        .customerIpAddress}
                  </Col>
                </Row>
              </Col>
            </Row> */}

            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Trading Address Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <Col md={12}>
                    <Row className="detail-info row">
                      <Col md={6}>Trading Address</Col>
                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingAddress ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingAddress : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Trading Status</Col>

                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingState ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingState : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Trading City</Col>
                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingCity ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingCity : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Trading Zip</Col>
                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingPostal ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingPostal : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Trading Country Code</Col>

                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingCountryISO ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybAddressList &&
                        getKybDetailsListRes.data.kybAddressList.tradingCountryISO : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Response ID</Col>
                      {/* {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.tradingCountryISO} */}
                      -
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verification status</Col>
                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybDetailsList &&
                        getKybDetailsListRes.data.kybDetailsList.verifyStatus ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybDetailsList &&
                        getKybDetailsListRes.data.kybDetailsList.verifyStatus : "-"
                      }
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verification Description</Col>

                      {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.description}</Col>;
                      })} */}
                      -
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verification Type</Col>

                      {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.checkType}</Col>;
                      })} */}
                      -
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Score</Col>
                      -
                      {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.fraudScore}</Col>;
                      })} */}
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Recommendation</Col>
                      -
                      {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.recommendation}</Col>;
                      })} */}
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Confidence Level</Col>
                      -
                      {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.confidenceLevel}</Col>;
                      })} */}
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verified On</Col>
                      -
                      {/* {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybDetailsList &&
                    getKybDetailsListRes.data.kybDetailsList.verifiedBy} */}
                    </Row>
                    <hr />
                    <Row className="detail-info row">
                      <Col md={6}>Verified By</Col>

                      {getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybDetailsList &&
                        getKybDetailsListRes.data.kybDetailsList.verifiedBy ?
                        getKybDetailsListRes.data &&
                        getKybDetailsListRes.data.kybDetailsList &&
                        getKybDetailsListRes.data.kybDetailsList.verifiedBy : "-"
                      }
                    </Row>
                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>
            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    className="themeText"
                  >
                    Document Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>

                  <Col md={12}>
                    <Row className="detail-info row">
                      {/* <Col md={6}></Col> */}
                      <Col sm={12} md={12}>
                        {getKybDetailsListRes && getKybDetailsListRes.data && getKybDetailsListRes.data.kybDetailsList && getKybDetailsListRes.data.kybDetailsList.docIdType && <Card >
                          <CardTitle>
                            {/* <h6>Front Pic</h6> */}

                          </CardTitle>
                          <CardBody>
                            <img
                              src={`data:image/jpeg;base64,${getKybDetailsListRes.data.kybDetailsList.docIdType}`}
                              style={{ maxWidth: "100%" }}
                            />
                            <br />
                            <br />
                            <h6 style={{ display: "inline" }}>
                              {getKybDetailsListRes.data.kybDetailsList.fileName}
                            </h6>
                            <a
                              download={getKybDetailsListRes.data.kybDetailsList.fileName}
                              href={`data:image/jpeg;base64,${getKybDetailsListRes.data.kybDetailsList.docIdType}`}
                            >
                              <GetAppIcon />
                            </a>
                          </CardBody>
                        </Card>}
                      </Col>
                    </Row>

                  </Col>
                </AccordionDetails>
              </Accordion>
            </div>


            {
              getKybDetailsListRes.data.kybDetailsList &&
              getKybDetailsListRes.data.kybDetailsList.verifyStatus == "Approve" && (
                <Row className="detail-info row">
                  <Col
                    md={12}
                    style={{ textAlign: "center", marginTop: "1rem" }}
                  >
                    <CustomButton
                      disabled
                      style={{
                        padding: "8px"
                      }}
                    >
                      Approve <ThumbUpIcon />
                    </CustomButton>
                    <CustomButton
                      disabled
                      style={{
                        padding: "8px"
                      }}
                    >
                      Reject <ClearIcon />
                    </CustomButton>
                  </Col>
                </Row>
              )}
            {
              getKybDetailsListRes.data.kybDetailsList &&
              getKybDetailsListRes.data.kybDetailsList.verifyStatus == "Reject" && (
                <Row className="detail-info row">
                  <Col
                    md={12}
                    style={{ textAlign: "center", marginTop: "1rem" }}
                  >
                    <CustomButton
                      disabled
                      style={{
                        padding: "8px"
                      }}
                    >
                      Approve <ThumbUpIcon />
                    </CustomButton>
                    <CustomButton
                      disabled
                      style={{
                        padding: "8px"
                      }}
                    >
                      Reject <ClearIcon />
                    </CustomButton>
                  </Col>
                </Row>
              )}
            {getKybDetailsListRes.data.kybDetailsList &&
              getKybDetailsListRes.data.kybDetailsList.verifyStatus == "Pending" && (
                <Row className="detail-info row">
                  <Col
                    md={12}
                    style={{ textAlign: "center", marginTop: "1rem" }}
                  >
                    <CustomButton
                      style={{
                        padding: "8px"
                      }}
                      onClick={() =>
                        handleAcceptOrRejectReq(
                          getKybDetailsListRes.data.kybAddressList.customerId,
                          userRole,
                          getKybDetailsListRes.data.kybAddressList.companyId,
                          "Approve"
                        )
                      }
                    >
                      Approve <ThumbUpIcon />
                    </CustomButton>
                    <CustomButton
                      style={{
                        padding: "8px"
                      }}
                      onClick={() =>
                        handleAcceptOrRejectReq(
                          getKybDetailsListRes.data.kybAddressList.customerId,
                          userRole,
                          getKybDetailsListRes.data.kybAddressList.companyId,
                          "Reject"
                        )
                      }
                    >
                      Reject <ClearIcon />
                    </CustomButton>
                  </Col>
                </Row>
              )}
            {/* <Row>
              <h3
                style={{
                  marginTop: "4rem",
                  marginLeft: "1rem",
                  color: "#013c83",
                  fontSize: "1.4rem",
                }}
              >
                Trading Address Details
              </h3>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Trading Address</Col>
                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybAddressList &&
                    getKybDetailsListRes.data.kybAddressList.tradingAddress}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Trading Status</Col>

                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybAddressList &&
                    getKybDetailsListRes.data.kybAddressList.tradingState}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Trading City</Col>
                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybAddressList &&
                    getKybDetailsListRes.data.kybAddressList.tradingCity}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Trading Zip</Col>
                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybAddressList &&
                    getKybDetailsListRes.data.kybAddressList.tradingPostal}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Trading Country Code</Col>

                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybAddressList &&
                    getKybDetailsListRes.data.kybAddressList.tradingCountryISO}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Response ID</Col>
                  {getKybDetailsListRes.data &&
                      getKybDetailsListRes.data.kybAddressList &&
                      getKybDetailsListRes.data.kybAddressList.tradingCountryISO}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verification status</Col>
                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybDetailsList &&
                    getKybDetailsListRes.data.kybDetailsList.verifyStatus}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verification Description</Col>

                  {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.description}</Col>;
                      })}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verification Type</Col>

                  {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.checkType}</Col>;
                      })}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Score</Col>

                  {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.fraudScore}</Col>;
                      })}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Recommendation</Col>

                  {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.recommendation}</Col>;
                      })}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Confidence Level</Col>

                  {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
                    getCustomerDetailsResArray.customerMasterDetailsResponseVO
                      .kycAndKybDetailsList &&
                    []
                      .concat(
                        getCustomerDetailsResArray
                          .customerMasterDetailsResponseVO.kycAndKybDetailsList
                      )
                      .map((detail, i) => {
                        return <Col md={3}>{detail.confidenceLevel}</Col>;
                      })}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verified On</Col>

                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybDetailsList &&
                    getKybDetailsListRes.data.kybDetailsList.verifiedBy}
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Verified By</Col>

                  {getKybDetailsListRes.data &&
                    getKybDetailsListRes.data.kybDetailsList &&
                    getKybDetailsListRes.data.kybDetailsList.verifiedBy}
                </Row>
              </Col>
            </Row> */}
          </Box>
        </div>
      </Layout>
    </>
  );
};

export default GetKybDetails;
